import ErrorScreen from './error-screen.component';

export default ErrorScreen;
